import { ref } from 'vue'

// Module-level state so any composable call shares the same bar
const active = ref(false)
let doneTimer: ReturnType<typeof setTimeout> | null = null

export function useProgressBar() {
  function start() {
    if (doneTimer) clearTimeout(doneTimer)
    active.value = true
  }

  function done() {
    doneTimer = setTimeout(() => {
      active.value = false
    }, 400)
  }

  return { active, start, done }
}
